import { RequiredConditionalMandatory } from '../types/ViewModel/RequiredConditionalMandatory';
import { RequiredConditionalMandatoryBM } from '../types/BusinessModel/RequiredConditionalMandatoryBM';

export class RequiredConditionalMandatoryFactory {
    public newRequiredConditionalMandatoryArray(
        requiredConditionalMandatoryList: RequiredConditionalMandatoryBM[],
        eventTypeGroupId: number
    ): RequiredConditionalMandatory[] {
        const requiredConditionalMandatoryArray: RequiredConditionalMandatory[] = [];
        if (requiredConditionalMandatoryList && requiredConditionalMandatoryList.length > 0) {
            requiredConditionalMandatoryList.map((cmItem) => {
                requiredConditionalMandatoryArray.push(this.createNewRequiredConditionalMandatoryItem(cmItem, eventTypeGroupId));
            });
        }
        return requiredConditionalMandatoryArray;
    }

    private createNewRequiredConditionalMandatoryItem(item: RequiredConditionalMandatoryBM, eventTypeGroupId: number): RequiredConditionalMandatory {
        return new RequiredConditionalMandatory(
            item.requiredConditionalMandatoryId,
            eventTypeGroupId,
            item.requiredPreviousTypeId,
            item.notAfterEventTypeId,
            '',
            ''
        );
    }
}
